import _regenerator from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import { getToken } from '@/utils/storage';
import store from '@/store/index';
var originalPush = VueRouter.prototype.push;

// 处理路由跳转会报错的问题
VueRouter.prototype.push = function push() {
  for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }
  return originalPush.apply(this, rest).catch(function (err) {
    return err;
  });
};
Vue.use(VueRouter);
// 自动扫描 modules 里面的路由模块，路由模块请根据业务自行拆分
var files = require.context('./modules', false, /\.js$/);
var routes = [];
// 获取所有的路由内容
files.keys().forEach(function (key) {
  var file = files(key).default;
  // 根据导出的内容判断是否数组，如果数组需使用扩展运算符
  if (Array.isArray(file)) {
    routes.push.apply(routes, _toConsumableArray(file));
  } else {
    routes.push(file);
  }
});
var constantRoutes = [
// 无权限页面
{
  path: '/no-permission',
  name: 'NoPermission',
  component: function component() {
    return import('@/views/error-page/no-permission');
  },
  meta: {
    title: '访问无权限'
  }
},
// 预览分享内容
{
  path: '/taxLaw/mini-program-preview-share',
  name: 'miniProgramPreviewShare',
  component: function component() {
    return import('@/views/taxLaw/share/mini-program-preview-share.vue');
  },
  meta: {
    title: '会话分享'
  }
},
// PC预览分享内容
{
  path: '/taxLaw/pc-preview-share',
  name: 'pcPreviewShare',
  component: function component() {
    return import('@/views/taxLaw/share/pc-preview-share-chat.vue');
  },
  meta: {
    title: '会话分享'
  }
},
// pc生成分享界面
{
  path: '/taxLaw/pc-generate-share',
  name: 'pcGenerateShare',
  component: function component() {
    return import('@/views/taxLaw/share/pc-generate-share.vue');
  },
  meta: {
    title: '会话分享'
  }
},
// 首页
{
  path: '/index',
  name: 'index',
  component: function component() {
    return import('@/views/index');
  },
  meta: {
    title: ''
  }
},
// AI合规小程序
{
  path: '/compliance',
  name: 'compliance',
  component: function component() {
    return import('@/views/compliance/home/index');
  },
  meta: {
    title: ''
  }
},
// AI盛瑞法规库
{
  path: '/taxLaw',
  name: 'taxLaw',
  component: function component() {
    return import('@/views/taxLaw/home/index');
  },
  meta: {
    title: 'AI法规秘书'
  }
},
// 404 页面路由
{
  path: '*',
  name: 'NotFound',
  component: function component() {
    return import('@/views/error-page/404');
  },
  meta: {
    title: '页面走丢了'
  }
}];
var createRouter = function createRouter() {
  return new VueRouter({
    // mode: 'history', // require service support
    base: process.env.BASE_URL,
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: [].concat(constantRoutes, routes)
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// 白名单
// const whiteList = ['']

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var _to$query, _to$query2;
    var token, userInfo;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (((_to$query = to.query) === null || _to$query === void 0 ? void 0 : _to$query.type) === 'taxLaw') {
            document.title = 'AI法规秘书';
          } else if (((_to$query2 = to.query) === null || _to$query2 === void 0 ? void 0 : _to$query2.type) === 'compliance') {
            document.title = 'AI合规秘书';
          }
          token = getToken();
          userInfo = store.getters['userInfo'] || {};
          if (!(!!token && !userInfo.id)) {
            _context.n = 1;
            break;
          }
          _context.n = 1;
          return store.dispatch('user/getUserInfo').catch(function () {
            console.error('获取用户信息失败');
          });
        case 1:
          next();
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
export default router;